import React from 'react';
import styled from 'styled-components';
import { Subscribe } from 'unstated';

import MainContainer, { mainContainer } from '../../containers/mainContainer';

const Modal = styled.div`
  display: ${props => (props.show ? 'block' : 'none')};
  position: fixed;
  z-index: 3;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
`;
const ModalContainer = styled.div`
  position: absolute;
  background-color: #fefefe;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #888;
  border-radius: 10px;
  padding: 1rem;
  width: 80%;
  height: 80%;
  overflow-y: scroll;
  text-align: center;
  animation: popout 1s;
  @keyframes popout {
    0% {
      height: 10%;
      width: 10%;
    }
    100%: {
      height: 80%;
      width: 80%;
    }
  }
`;
const ModalTitle = styled.h1`
  text-align: center;
  color: #ed5a5c;
  text-transform: capitalize;
`;
const ModalHeading = styled.h2`
  margin-left: 1rem;
  color: #5b5f97;
`;
const ModalDescription = styled.div`
  color: #0c7489;
`;
const ModalLinkDiv = styled.div`
  display: inline-block;
  margin: 1rem;
  padding: 1rem;
  width: 6rem;
  height: 2rem;
  color: #fff;
  background-color: #0c7489;
  border-radius: 4px;
  line-height: 2rem;
  :hover {
    background-color: #0a5f71;
  }
`;
const ModalImage = styled.img`
  width: 80%;
  margin: 10px;
  border: 1px solid #b381f2;
  border-radius: 4px;
`;
const CloseButton = styled.button`
  font-size: 1rem;
  height: 48px;
  width: 96px;
  border-radius: 12px;
  margin: 10px 5px;
`;

const handleCloseModal = () => {
  mainContainer.setState({ isModalOpen: false, projectDetail: null });
};

const handleKeyUp = event => {
  console.log(event);
  if (event.key === 27) console.log('event');
};

const ReactModal = props => {
  return (
    <Subscribe to={[MainContainer]}>
      {container => {
        return container.state.projectDetail ? (
          <Modal show={container.state.isModalOpen} onKeyDown={handleKeyUp}>
            <ModalContainer>
              <ModalTitle>{container.state.projectDetail.name}</ModalTitle>
              <section>
                <ModalHeading>Description:</ModalHeading>
                <ModalDescription>
                  {container.state.projectDetail.description}
                </ModalDescription>
              </section>
              <section>
                <ModalHeading>Link:</ModalHeading>
                <a
                  href={container.state.projectDetail.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ModalLinkDiv>Link</ModalLinkDiv>
                </a>
              </section>
              <section>
                <ModalHeading>Screenshots:</ModalHeading>
                {container.state.projectDetail.image.map((image, index) => (
                  <ModalImage src={image} key={index} />
                ))}
              </section>
              <CloseButton onClick={handleCloseModal}>close</CloseButton>
            </ModalContainer>
          </Modal>
        ) : null;
      }}
    </Subscribe>
  );
};

export default ReactModal;
